import React, { useState, useEffect, useRef, useContext } from 'react';
import { addBusinessDays } from 'date-fns';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { format } from 'date-fns';
import Select from 'react-select';
import { useNavigate, useLocation } from 'react-router-dom';
import { Audio } from 'react-loader-spinner';
import { MdOutlineCancel } from 'react-icons/md';
import { FaEdit, FaTrash,FaPen, FaCalculator  } from 'react-icons/fa';
import { BsFillSendFill } from "react-icons/bs";
import { Layout, Header, Modal,  DescriptionModal, CalculatorModal} from '../../../../components';
import { handleApi, formatCurrency, capitalize, inputDate,formatMediumDate,formatTwoDecimal,deepEqual } from '../../../../utils/utils';
import AppContext from '../../../../contexts/AppContext';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const EditDelivery = () => {
  const location = useLocation();
  const { order } = location.state || {};
  console.log('recived order sir',order)

 const { userData, currentColor, actionCount, setActionCount } = useContext(AppContext);
 console.log('userdata',userData?.data?.employees?.id)
  const [delivery, setDelivery] = useState(() => {
    // Check if quote exists and has required data
    const goods = order?.transactionLines?.length > 0
      ? order.transactionLines.map((line) => ({
        // Only select the fields you want from the quote's transaction line
        id: line.id || null,  
        product_id: line.product_id || null,  
        description: line.description || line.products.name || '',    
          ordered_quantity: line.quantity || 1,  
          delivered_quantity: 0,      
          outstanding_quantity: (line.quantity|| 0) - (0 || 0),  // Calculate total as unit_price * quantity
        }))
      : [{
        id: 0  ,
        product_id: 0 ,
        description: '',    
        ordered_quantity: 0,  
        delivered_quantity: 0,      
        outstanding_quantity: 0,  // Calculate total as unit_price * quantity
      }];
      return {
        date: null,
        employee_id:userData?.data?.employees?.id ||'',
        id: order?.id || '',
        transactionLines: goods,  // Initialize transaction lines
      };
    });
    const [delivered, setDelivered] = useState([]);
    const [deliveries, setDeliveries] = useState([]);
    const [selectedDeliveryId, setSelectedDeliveryId] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [editedLineIndex, setEditedLineIndex] = useState(null);
    const [selectedLineIndex, setSelectedLineIndex] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isCalculatorOpen, setIsCalculatorOpen] = useState(false);
    const [startDate, setStartDate] = useState(new Date(delivery.date));
    // const [open, setOpen] = useState(false);
    const [openDeliveryId, setOpenDeliveryId] = useState(null);
   
    const navigate = useNavigate();
    const quantityRefs = useRef([]);
    // const dateInputRef = useRef(null);
    const datePickerRef = useRef(null);
    const itemRefs = useRef([]);

    useEffect(() => {
      const fetchData = async () => {
        await fetchDeliveries();
        console.log('delivered sir',delivered)
      };
      fetchData();
    }, []); // Empty dependency array ensures this runs only once when the component mounts

    useEffect(() => {
      // Only run after deliveries are fetched
      if (deliveries.length === 0) {
        const createInitialDelivery = async () => {
          await createDelivery();    // Your API call to create a delivery
         // await fetchDeliveries();   // Refresh deliveries after creation
        };
        createInitialDelivery();
      }
    }, [deliveries]);

    useEffect(() => {
      function handleClickOutside(event) {
        if (datePickerRef.current && !datePickerRef.current.contains(event.target)) {
          setOpenDeliveryId(null); // Close the date picker
        }
      }
    
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, []);
  
    
    const createDelivery = () => {
  if (!order || !order.transactionLines || order.transactionLines.length === 0) {
    console.warn("Invalid order or no transaction lines available.");
    return null;
  }

  const newDelivery = [
    {
      id: 1,
      order_id: order.id,
      date: new Date().toISOString(), // or use order.date if needed
      // action:'new', // create new delivery
      transactionLines: order.transactionLines.map(line => ({
        order_line_id: line.id,
        product_id: line.product_id,
        product_name:line.products.name,
        ordered_quantity: line.quantity,
        delivered_quantity: 0,
      })),
    },
  ];
  setSelectedDeliveryId(1);
  setDeliveries(newDelivery);
};


    const fetchDeliveries = async () => {
        const apiEndpoint = 'purchase/deliveries';
        const apiMethod = 'GET';
        const cleanedData = {};
    
        const parameters = {order_id:delivery.id || 0};
        //const parameters = {};
        setIsLoading(true);
        try {
          const response = await handleApi(apiEndpoint, cleanedData, userData, apiMethod, parameters);
          if (response.error) {
            toast.error(`Error fetching report: ${response.errorMessage}`);
            return;
          }
          const { status, statusText, data } = response;
          if (status === 200) {
            console.log('data from api sir',data)

            const filteredDeliveries = data.map(delivery => ({
              id: delivery.id,
              action:'edit', // edit existing  delivery
              order_id: delivery.order_id,
              date: delivery.date,
              transactionLines: delivery.transactionLines?.map(line => ({
                order_line_id: line.order_line_id,
                product_id: line.product_id,
                product_name:line.products.name,
                ordered_quantity: line.ordered_quantity,
                delivered_quantity: line.delivered_quantity,
              })),
            }));
            setDeliveries(filteredDeliveries);
            setSelectedDeliveryId(data[0].id);
          }else { toast.error(`Error ${status}: ${statusText}`); }
        } catch (error) {
          setSelectedDeliveryId(1);
          
          //toast.error(error.message || 'An unexpected error occurred.');
        } finally {setIsLoading(false);}
      };
    

      
    const handleOpenCalculator = (index) => {
        setEditedLineIndex(index);
        setIsCalculatorOpen(true);
        setIsModalOpen(true); // Ensure the main modal is opened too 
    };
    
    const handleSaveCalculatedQuantity = (calculatedQuantity) => {
      const updatedTransactionLines = [...delivery.transactionLines];
      updatedTransactionLines[selectedLineIndex].quantity = calculatedQuantity;
      updatedTransactionLines[selectedLineIndex].total = (updatedTransactionLines[selectedLineIndex].unit_price * calculatedQuantity) * (1 - updatedTransactionLines[selectedLineIndex].discount_percentage / 100);
      setDelivery({ ...delivery, transactionLines: updatedTransactionLines });
      setIsModalOpen(false);
    };
    
    const handleDateChange = (date, deliveryId) => {
      const formattedDate=inputDate(date);
      setDeliveries((prevDeliveries) =>
        prevDeliveries.map((delivery) =>delivery.id === deliveryId ? { ...delivery, formattedDate } : delivery)
      );
    
      // Optional: update backend
      // updateDeliveryDate(deliveryId, date); // If you have an API call
    };

    const handleTransactionLineChange = (index, event) => {
      const { name, value } = event.target;
    
      setDeliveries(prevDeliveries => {
        return prevDeliveries.map(delivery => {
          if (delivery.id !== selectedDeliveryId) return delivery;
    
          // Clone the transaction lines array
          const updatedTransactionLines = [...delivery.transactionLines];
          const updatedLine = { ...updatedTransactionLines[index] };
    
          if (name === 'delivered_quantity') {
            updatedLine.delivered_quantity = value;
    
            const parsed = parseFloat(value);
            updatedLine.outstanding_quantity = isNaN(parsed)
              ? updatedLine.ordered_quantity
              : updatedLine.ordered_quantity - parsed;
          }
    
          updatedTransactionLines[index] = updatedLine;
    
          return {
            ...delivery,
            transactionLines: updatedTransactionLines,
          };
        });
      });
    };
  
    /*const handleTransactionLineChange = (index, event) => {
      const updatedTransactionLines = [...delivery.transactionLines];
      const updatedLine = updatedTransactionLines[index];
      const { name, value } = event.target;
    
      
      if (name === 'delivered_quantity') {
        // Allow raw input first
        updatedLine.delivered_quantity = value;
      
        // Optionally update outstanding_quantity only if it's a valid number
        const parsed = parseFloat(value);
        if (!isNaN(parsed)) {
          updatedLine.outstanding_quantity = updatedLine.ordered_quantity - parsed;
        } else {
          updatedLine.outstanding_quantity = updatedLine.ordered_quantity;
        }
      }
      // Handle description change
      
   
      setDelivery({ ...delivery, transactionLines: updatedTransactionLines });
    }; */
  


    
    const handleApiWithTimeout = async (url, data, userData, method, parameters, timeout = 5000) => { // Timeout helper for API calls
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), timeout);
  
      try {
        const response = await handleApi(url, data, userData, method, parameters, { signal: controller.signal });
        return response;
      } catch (error) {
        if (error.name === 'AbortError') {
          toast.error('Request timed out');
        } else {
          toast.error('Error: ' + error.message);
        }
        throw error;
      } finally {
        clearTimeout(timeoutId);
      }
    };
  
    const handleSubmit = async (e,c) => {
        if (e && e.preventDefault) {e.preventDefault();} // Prevent default only if e is present  
      
      
        const selectedDelivery = deliveries.find(delivery => delivery.id === selectedDeliveryId);
        // Format date to 'YYYY-MM-DD' before sending
    
        // Check if at least one item has a delivered_quantity > 0
        const hasDeliveredQuantity = selectedDelivery?.transactionLines?.some(
          line => Number(line.delivered_quantity) > 0
        );

        if (!hasDeliveredQuantity) {
          toast.warn('Please enter  delivered quantities !');
          if (quantityRefs.current[0]) {
            quantityRefs.current[0].focus();
          }
          return;
        }
        console.log('Selected Delivery sir:', selectedDelivery);
     
        const cleanedTransactionLines = selectedDelivery.transactionLines.map(line => ({
          delivered_quantity: line.delivered_quantity,
          order_line_id: line.order_line_id,
        }));

        const apiMethod = 'POST' ;
      // const apiMethod = selectedDelivery.action === 'new'? 'POST' : 'PUT';

      // Create the cleaned delivery object
      // Format date to 'YYYY-MM-DD' before sending
      const formattedDate = new Date(selectedDelivery.date).toISOString().split('T')[0];
      const cleanedDelivery = {
        ...selectedDelivery,
        date: formattedDate, // ✅ formatted date
        transactionLines: cleanedTransactionLines,
      };
      // const cleanedDelivery = {...selectedDelivery,transactionLines: cleanedTransactionLines,};
      console.log({ cleanedDelivery })
      const parameters = {};
      // const parameters = apiMethod === 'POST' ? {}: { id: delivery.id };
      console.log('cWHAT ACTION SIR sir',parameters );
  
      
      setIsLoading(true);
      try {
        const response = await handleApi('purchase/deliveriess', cleanedDelivery, userData, apiMethod,parameters);
        if (response.status === 200) {toast.success('Order updated  successfully.');
        }else {toast.error('Error saving Order.', response.statusText);}
      } catch (error) {
        toast.error('Error saving Order: ' + error.message);
      } finally {
        setActionCount(actionCount + 1);
        setIsLoading(false);
      }
    };
    console.log('selected delivery id sir',selectedDeliveryId)
       
    const handleClose = () => { navigate(-1);   }; // Navigate back when closing the form
    const employee = userData?.data?.employees;
    const fullName = capitalize(`${employee?.first_name ?? ''} ${employee?.last_name ?? ''}`.trim());

  return (
    <Layout>
  {/* <div className="m-4 bg-gray-900 rounded-2xl shadow-xl p-6"> */}
  <div className=" bg-gray-800 rounded-xl shadow-2xl p-2">
    <ToastContainer position="top-center" autoClose={2000} />
    <div className="text-center py-4 border-b border-gray-700">
      <div className="w-full flex justify-end">
        <button
          className="text-white hover:text-gray-400 py-1 px-2 rounded-full transition-all duration-300"
          title="Close"
          onClick={handleClose}
        >
          <MdOutlineCancel size={24} color={currentColor} />
        </button>
      </div>
      <div className="mx-4 text-white">
        <Header category="Purchase" title="Receive Goods" color={currentColor} />
      </div>
    </div>

    {/* Loading State */}
    {isLoading ? (
      <div className="flex flex-col items-center py-6">
        <Audio height="80" width="80" color="white" ariaLabel="loading" />
        <p className="mt-4 text-white text-sm">Processing order...</p>
      </div>
    ) : (
      // <div className="bg-gray-800 p-6 my-4 rounded-2xl shadow-xl max-w-full mx-auto">
      <div className="bg-white p-6 my-4 rounded-xl shadow-2xl">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
           {/* Supplier Information */}
           <div className="p-4 bg-gray-800 text-gray-200 rounded-xl shadow-xl hover:shadow-2xl transition-all duration-300 border border-gray-700">
  <p className="text-sm text-blue-400 font-semibold mb-4 uppercase tracking-wider text-center">Supplier </p>
  <div className="space-y-2 text-sm">
    <div className="flex justify-between">
      <span className="text-gray-400">Supplier Name:</span>
      <span className="font-medium">{order?.partners?.name || 'N/A'}</span>
    </div>
    <div className="flex justify-between">
      <span className="text-gray-400">Contact Person:</span>
      <span>{order?.partners?.contact_person || 'N/A'}</span>
    </div>
    <div className="flex justify-between">
      <span className="text-gray-400">Phone:</span>
      <span className="font-semibold">{order?.partners?.phone_number || 'N/A'}</span>
    </div>
    <div className="flex justify-between">
      <span className="text-gray-400">Email:</span>
      <span>{order?.partners?.email || 'N/A'}</span>
    </div>
  </div>
</div>


<div className="p-4 bg-gray-800 text-gray-200 rounded-xl shadow-xl hover:shadow-2xl transition-all duration-300 border border-gray-700">
  <h3 className="text-sm text-blue-400 font-semibold mb-4 uppercase tracking-wider text-center">Purchase Order</h3>
  <div className="space-y-2 text-sm">
    <div className="flex justify-between">
      <span className="text-gray-400">Order No.:</span>
      <span className="font-medium">{order?.reference || 'N/A'}</span>
    </div>
    <div className="flex justify-between">
      <span className="text-gray-400">Date:</span>
      <span>{formatMediumDate(order?.date)}</span>
    </div>
    <div className="flex justify-between">
      <span className="text-gray-400">Order Status:</span>
      <span
        className={`uppercase font-bold ml-2 ${
          order?.state === 'draft'
            ? 'text-yellow-400'
            : order?.state === 'approved'
            ? 'text-blue-400'
            : order?.state === 'cancelled'
            ? 'text-red-400'
            : order?.state === 'deleted'
            ? 'text-gray-500'
            : order?.state === 'paid'
            ? 'text-green-400'
            : 'text-yellow-400'
        }`}
      >
        {order?.state || 'Pending'}
      </span>
    </div>
  </div>
</div>

         
        </div>


        {/* Received Goods (Deliveries List) */}
        <div className="my-4 p-2 bg-gray-50 rounded-lg hover:shadow-2xl transition-all duration-300 max-w-fit mx-auto">
          <p className="text-lg text-center font-semibold text-blue-500 uppercase">Received Goods</p>
          <div className="space-y-4">
            {deliveries.map((delivery) => (
              <div
                key={delivery.id}
                className="flex items-center justify-between bg-gray-800 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 p-2 cursor-pointer"
                // onClick={() => setSelectedDeliveryId(selectedDeliveryId === delivery.id ? null : delivery.id)} // Toggle the selection
              >
                {/* Delivery ID */}
                <div className="text-center flex-1">
                  <strong className="text-sm font-medium text-gray-300">Delivery #{delivery.id}</strong>
                </div>

                {/* Delivery Date */}
                 {/* <div className="text-center flex-1">
                  <p className="text-xs text-gray-400">{formatMediumDate(delivery.date)}</p>
                </div>  */}
                <div className="text-center ml-4 flex-1">
                <button
                  // onClick={() => setOpen(!open)}
                  onClick={() =>
                    setOpenDeliveryId(openDeliveryId === delivery.id ? null : delivery.id)
                  }
                  className="text-xs text-gray-400 hover:text-blue-500 transition duration-200 ease-in-out flex flex-col items-center"
                >
                  <span>{format(new Date(delivery.date), 'MMM d')},</span>
                  <span className="text-xs text-gray-400">{format(new Date(delivery.date), 'yyyy')}</span>
                </button>

           
            

                {openDeliveryId === delivery.id && (
  <div
    ref={datePickerRef}
    className="absolute z-50 mt-2 left-1/2 -translate-x-1/2 shadow-lg"
  >
    <DatePicker
      selected={new Date(delivery.date)}
      onChange={(date) => {
        handleDateChange(date, delivery.id);
        setOpenDeliveryId(null); // ✅ Close after selecting
      }}
      inline
      showYearDropdown
      showMonthDropdown
      yearDropdownItemNumber={100}
      dateFormat="MMMM d, yyyy"
      minDate={new Date(2020, 0, 1)}
      maxDate={new Date()}
      className="rounded-md border border-gray-300 bg-white"
    />
  </div>
)}
              </div>

                {/* Toggle Icon */}
                <div
                  className={`w-5 h-5 bg-blue-500 ml-2 text-white rounded-full flex items-center justify-center transition-transform duration-300 transform ${
                    selectedDeliveryId === delivery.id ? 'rotate-45' : ''
                  }`}
                  onClick={() => setSelectedDeliveryId(selectedDeliveryId === delivery.id ? null : delivery.id)} // Toggle the selection
       
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    className="w-3 h-3"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M4 6h16M4 12h16M4 18h16"
                    />
                  </svg>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Delivered Transaction Lines (Display Items and Allow Data Input) */}
        {selectedDeliveryId && deliveries.map((delivery) => (
          selectedDeliveryId === delivery.id && (
            <div key={delivery.id} className="my-4 p-6 bg-gray-700 rounded-lg transition-all duration-300 max-w-fit mx-auto">
              {/* Table Header */}
              <div className="grid grid-cols-[minmax(200px,1fr)_80px_120px_90px] gap-4 text-sm p-4 border-b text-gray-300 font-semibold">
                <div className="text-left">Product Description</div>
                <div className="text-center">Ordered</div>
                <div className="text-center">Delivered</div>
                <div className="text-center">Outstanding</div>
              </div>

              {/* Table Content */}
              {delivery.transactionLines.length ? (
                delivery.transactionLines.map((line, index) => (
                  <div
                    key={index}
                    className="grid grid-cols-[minmax(200px,1fr)_80px_120px_90px] gap-4 px-4 border-b bg-gray-800 hover:bg-gray-700 text-sm transition-all duration-200"
                  >
                    <div className="text-gray-300 mt-2" >{line.product_name}</div>
                    <div className="text-center mt-2  text-gray-300">{Math.round(line.ordered_quantity)}</div>
                    <div className="relative">
                      <input
                        name="delivered_quantity"
                        ref={(el) => (quantityRefs.current[index] = el)}
                        value={line.delivered_quantity}
                        onChange={(e) => handleTransactionLineChange(index, e)}
                        className="w-full text-center text-gray-700 px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-300"
                        placeholder="0"
                      />
                      <button
                        type="button"
                        className="absolute top-1/2 right-2 transform -translate-y-1/2 text-gray-500 hover:text-blue-600"
                        title="Calculate quantity"
                        onClick={() => handleOpenCalculator(index)}
                        disabled={!line.product_id}
                      >
                        <FaCalculator size={14} />
                      </button>
                    </div>
                    <div className="text-center text-gray-300 mt-2">{Math.round(line.ordered_quantity-line.delivered_quantity)}</div>
                  </div>
                ))
              ) : (
                <div className="text-center text-gray-500 py-4">No order details found</div>
              )}
            </div>
          )
        ))}

        {/* Action Buttons */}
        <div className="flex justify-center space-x-6 mt-6">
          <button
            onClick={handleSubmit}
            className="bg-blue-600 text-white px-6 py-3 rounded-xl hover:bg-blue-700 transition-all duration-300 flex items-center gap-2"
          >
            <BsFillSendFill size={20} />
            <span>Submit</span>
          </button>

          <button
            onClick={handleClose}
            className="bg-blue-500 text-white px-6 py-3 rounded-xl hover:bg-blue-600 transition-all duration-300 flex items-center gap-2"
          >
            <MdOutlineCancel size={20} />
            <span>Close</span>
          </button>
        </div>
      </div>
    )}
  </div>

  {/* Modal for Calculator */}
  <Modal open={isModalOpen} onClose={() => setIsModalOpen(false)} minWidth="90%">
    {isCalculatorOpen && (
      <CalculatorModal
        isOpen={isCalculatorOpen}
        onClose={() => setIsCalculatorOpen(false)}
        onSave={handleSaveCalculatedQuantity}
        defaultQuantity={delivery.transactionLines[selectedLineIndex]?.quantity}
      />
    )}
  </Modal>
</Layout>




  );
};
export default EditDelivery;
